import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import _ from "lodash";
import React, { useState } from "react";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../../components/page-header";
import { EntTerritorialsUnits } from "../../../../models/handBooks/territorialsUnits";
import { useTerritorialUnit } from "./useTerritorialUnits";
import { EntTerritorialUnitsFilter } from "../../../../models/filters/territorialUnitsFilter";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetTerritorialUnitsListQuery } from "../../../../redux/api/handBooksApi/territorialUnitsApi";
import { useTranslation } from "react-i18next";
import { AddTerritorialUnitModal } from "./AddTerritorialUnitsModal";
import { FilterByNameHB } from "../../../../components/filterByNameHB/FilterByNameHB";

enum FormField {
  name,
}
export const TerritorialUnits = () => {
  const [form] = useForm();
  const { t } = useTranslation()
  const [modal, contextHolder] = Modal.useModal();
  const [selectedTerritorialUnit, setSelectedTerritorialUnit] = useState<EntTerritorialsUnits>(new EntTerritorialsUnits());
  const [showModal, setShowModal] = useState<boolean>(false);
  const { onAddTerritorialUnit, onEditTerritorialUnit, onDeleteTerritorialUnit } = useTerritorialUnit(modal, () => {
	searchHandleClick();
  })

  const [getArchiveFolders] = useLazyGetTerritorialUnitsListQuery();
  const {
	filter,
	fetching,
	data,
	access,
	totalItems,
	setData,
	setFetching,
	setFilter,
	scrollHandler,
	setCurrentPage
  } = useGetDataOnScroll<EntTerritorialsUnits, EntTerritorialUnitsFilter>({
	initialFilter: new EntTerritorialUnitsFilter(),
	query: getArchiveFolders
  });

  const [height, setHeight] = useState<number>(0);

  const openAddModal = (item: EntTerritorialsUnits) => {
	setSelectedTerritorialUnit(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntTerritorialUnitsFilter => {
	let filt: EntTerritorialUnitsFilter = _.clone(filter);
	filt.name = form.getFieldValue(FormField.name) ?? null;
	filt.page = 1;
	return filt;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } } onScroll={ scrollHandler }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.nameKy') }</th>
		  <th>{ t('general.nameRu') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ item?.nameKy }</td>
			<td>{ item?.nameRu }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeleteTerritorialUnit(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );

  return (
	<>
	  <PageHeader
		title={ t('titles.territorial_units') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } } type="secondary">
			{ t('handbooks.territorial_units.territorial_units_desc') } { t('general.records_found') } { totalItems }
		  </Typography.Text>
		}
	  />
	  {/* <Button type="primary" icon={<PlusOutlined />} onClick={() => { openAddModal(new EntTerritorialsUnits) }}>
        {t('handbooks.territorial_units.add_territorial_units')}
      </Button> */ }
	  <ContentPartFilter
		filter={ <FilterByNameHB onSearch={ searchHandleClick } onReset={ () => {
		  clearFields();
		  searchHandleClick()
		} } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
	  />
	  <AddTerritorialUnitModal
		territorialUnit={ selectedTerritorialUnit }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedTerritorialUnit.id !== 0 ? onEditTerritorialUnit : onAddTerritorialUnit }
	  />
	  { contextHolder }
	</>
  );
}
